import styles from './Base.module.css'
import React from 'react'
import PropTypes from 'prop-types'

const Base = ({
  id,
  onClick,
  disabled = false,
  'aria-label': ariaLabel,
  'aria-expanded': ariaExpanded,
  children,
  type = 'button',
  variant = 'default',
}) =>
  <button
    id={ id }
    type={ type }
    className={ `${styles.button} ${styles[variant] ?? ''}`.trim() }
    disabled={ disabled }
    aria-label={ ariaLabel }
    aria-expanded={ ariaExpanded }
    onClick={ e => {
      e.stopPropagation()
      e.preventDefault()
      onClick(e)
    } }
  >{ children }</button>

Base.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  'aria-label': PropTypes.string,
  'aria-expanded': PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  variant: PropTypes.oneOf(['default', 'full']),
}

export default Base
